import { useEffect, useState } from "react";
import {
	Container,
	FormLabel,
	Radio,
	FormControl,
	RadioGroup,
	FormControlLabel,
} from "@mui/material";
import useStore from "../store/store";
import accountService from "../services/account";
import {
	Text,
	Heading,
	Button,
	FormatPhone,
	AccountTypesDropdown,
	FormatCurrency,
	ArrowDownChip,
} from "../controls";

function AddAccount({ toggleDrawer, reload }) {
	let [title, setTitle] = useState("");
	let [phone, setPhone] = useState("");
	let [type, setType] = useState("");
	let [initialType, setInitialType] = useState("debit");
	let [initial, setInitial] = useState("");
	let [shopName, setShopName] = useState("");
	let [address, setAddress] = useState("");
	let [nickName, setNickName] = useState("");

	const {
		token,
		setErrorMessage,
		setSuccessMessage,
		setInfoMessage,
		setIsLoading,
		toEdit,
		setToEdit,
		currObj,
		setCurrObj,
	} = useStore((state) => state);

	useEffect(() => {
		if (currObj) {
			setTitle(currObj.title);
			setPhone(currObj.phone);
			currObj.initial < 0
				? setInitialType("debit")
				: setInitialType("credit");
			setType(currObj.type);
			setInitial(Math.abs(currObj.initial));
			setShopName(currObj.shopName);
			setAddress(currObj.address);
			setNickName(currObj.nickName);
		}
	}, []);

	const createAccount = () => {
		setIsLoading(true);
		!toEdit ? create() : edit();
	};

	const create = () => {
		initial = initialType === "credit" ? initial : -initial;
		let data = {
			title,
			type,
			initial,
			phone: phone.trim(),
			shopName,
			address,
			nickName,
		};
		accountService.create(token, data).then((r) => {
			if (r.error) {
				setErrorMessage(r.error);
				setIsLoading(false);
				return;
			}
			if (r.data) {
				setSuccessMessage("Account created successfully");
				clearForm();
			}
		});
	};

	const edit = () => {
		initial = initialType === "credit" ? initial : -initial;
		if (initial === undefined) initial = 0;
		let data = {
			id: currObj._id,
			title,
			type,
			initial,
			phone: phone.trim(),
			shopName,
			address,
			nickName,
		};
		accountService.update(token, data).then((r) => {
			if (r.error) {
				setErrorMessage(r.error);
				setIsLoading(false);
				return;
			}
			if (r.data) {
				setInfoMessage("Information updated successfully.");
				clearForm();
			}
		});
	};

	const clearForm = () => {
		setTitle("");
		setType("");
		setPhone("");
		setInitialType("debit");
		setInitial(0);
		setShopName("");
		setAddress("");
		setNickName("");

		setIsLoading(false);
		setToEdit(false);
		setCurrObj(null);
		reload();
		toggleDrawer();
	};

	return (
		<>
			<Container sx={{ overflow: "auto" }}>
				<Heading text="Create Account" variant="h6" />
				<Text label="Account Title" value={title} onChange={setTitle} />
				<AccountTypesDropdown
					label={"Account type"}
					value={type}
					onChange={setType}
				/>
				<FormControl>
					<RadioGroup
						aria-labelledby="radio"
						defaultValue="debit"
						name="radio-buttons-group"
						value={initialType}
						onChange={(e) => setInitialType(e.target.value)}
						style={{
							display: "flex",
							flexDirection: "row",
							alignItems: "center",
							marginLeft: "10px",
						}}
					>
						<FormLabel id="radio" sx={{ mr: 2 }}>
							Is initial balance debit or credit? (Optinal)
						</FormLabel>
						<FormControlLabel
							value="debit"
							control={<Radio />}
							label="Debit / بنام"
						/>
						<FormControlLabel
							value="credit"
							control={<Radio />}
							label="Credit / جمع"
						/>
					</RadioGroup>
				</FormControl>
				<FormatCurrency
					label="Initial Balance (Optinal)"
					value={initial}
					onChange={setInitial}
				/>
				<FormatPhone
					label="Phone (Optional)"
					value={phone}
					onChange={setPhone}
				/>
				{type !== "bank" && (
					<Text
						label="Shop Name (Optional)"
						value={shopName}
						onChange={setShopName}
					/>
				)}
				<Text
					label="Address (Optional)"
					value={address}
					onChange={setAddress}
				/>
				<Text
					label="Nick Name (Optional)"
					value={nickName}
					onChange={setNickName}
				/>
				<Button
					icon={<ion-icon name="add-circle-outline"></ion-icon>}
					onClick={createAccount}
					text="Create"
				/>
				<ArrowDownChip onClick={clearForm} />
			</Container>
		</>
	);
}

export default AddAccount;
